import { Partner } from "../../../api/staff";

export const getPartnersTableColumns = (t: (key: string) => string) => [
  { key: "id", name: t("admin.partners.columns.id"), sortable: false },
  { key: "name", name: t("admin.partners.columns.name"), sortable: true, sortKey: "name" },
  { key: "email", name: t("admin.partners.columns.email"), sortable: false },
  { key: "status", name: t("admin.partners.columns.status"), sortable: false },
  { key: "balance", name: t("admin.partners.columns.balance"), sortable: false },
  { key: "created_at", name: t("admin.partners.columns.createdAt"), sortable: true, sortKey: "created_at" },
  { key: "actions", name: "", sortable: false }
];

const PARTNER_STATUS_COLORS: Record<Partner["status"], string> = {
  active: "#17C964",
  wait_confirm: "#F5A524",
  wait_moderation: "#7828C8",
  wait_additional_data_for_moderation: "#006FEE",
  deactivated: "#F31260"
};

export const getPartnerStatusConfig = (
  status: Partner["status"],
  t: (key: string) => string
) => {
  const color = PARTNER_STATUS_COLORS[status] || "#71717A";

  const labelKeyMap: Record<Partner["status"], string> = {
    active: "admin.partners.status.active",
    wait_confirm: "admin.partners.status.waitConfirm",
    wait_moderation: "admin.partners.status.waitModeration",
    wait_additional_data_for_moderation: "admin.partners.status.waitAdditionalDataForModeration",
    deactivated: "admin.partners.status.deactivated"
  };

  const label =
    labelKeyMap[status] ? t(labelKeyMap[status]) : status;

  return {
    label,
    color
  };
};

const PARTNER_LEVEL_COLORS: Record<Partner["lvl"], string> = {
  new: "#17C964",
  base: "#71717A",
  pro: "#18181B",
  expert: "#7828C8"
};

export const getPartnerLevelConfig = (
  level: Partner["lvl"],
  t: (key: string) => string
) => {
  // Capitalize first letter for display
  const label = level.charAt(0).toUpperCase() + level.slice(1);

  // Цвета и фон для каждого уровня
  const levelStyles: Record<Partner["lvl"], { bg: string; text: string; color: string }> = {
    new: { bg: 'rgba(23, 201, 100, 0.2)', text: '#17C964', color: '#17C964' },
    base: { bg: '#EEEEEF', text: '#71717A', color: '#71717A' },
    pro: { bg: '#11181C', text: '#FFFFFF', color: '#18181B' },
    expert: { bg: 'rgba(120, 40, 200, 0.2)', text: '#7828C8', color: '#7828C8' }
  };

  const style = levelStyles[level] || { bg: '#F4F4F5', text: '#71717A', color: '#71717A' };

  return {
    label,
    color: style.color,
    bg: style.bg,
    text: style.text
  };
};
